<template>
    <v-dialog v-model="internalDialog" fullscreen max-width="100%">
        <template v-slot:activator="{ on, attrs }">
            <slot name="activator" :on="on" :attrs="attrs">
                <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
            </slot>
        </template>
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="handleClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ title }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="handleSave">{{ saveText }}</v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text>
                <v-container style="margin-top: 1%;">
                    <v-form ref="form" v-model="internalFormValid">
                        <v-row justify="center">
                            <v-col cols="12" sm="10">
                                <v-text-field
                                    :value="editedItem.titulo"
                                    @input="handleTituloInput"
                                    :label="titleLabel"
                                    clearable
                                    solo
                                    :disabled="isMetaTemplate"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2">
                                <v-text-field
                                    :value="editedItem.cod_template"
                                    @input="updateField('cod_template', $event)"
                                    :label="codeLabel"
                                    clearable
                                    solo
                                    :disabled="isCodDisabled"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="start">
                            <v-col cols="12" sm="10">
                                <v-text-field
                                    :value="editedItem.descricao"
                                    @input="handleFieldInput('descricao', $event)"
                                    @focus="handleFieldFocus('descricao', $event)"
                                    @click="handleFieldClick('descricao', $event)"
                                    @keyup="handleFieldKeyup('descricao', $event)"
                                    @keydown="handleFieldKeydown('descricao', $event)"
                                    :label="headerLabel"
                                    clearable
                                    solo
                                    ref="descricaoTextField"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center" style="margin-top: -15px;">
                            <v-col cols="12">
                                <v-btn 
                                    color="primary"
                                    small
                                    outlined
                                    @click="handleAddVariable('header')"
                                >
                                    {{ addVariableText }}
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row justify="start" v-if="variavelDescription.length > 0">
                            <v-col cols="12" sm="3" v-for="(variavel) in variavelDescription" :key="(variavel.campo || 'campos_descricao') + '-' + variavel.id">
                                <div style="display: flex; align-items: flex-start; gap: 8px;">
                                    <v-text-field
                                        v-model="variavel.value"
                                        :label="variableText + ' ' + variavel.key.replace(/\D/g, '')"
                                        outlined
                                        dense
                                        style="flex: 1;"
                                    ></v-text-field>
                                    <v-btn
                                        icon
                                        small
                                        color="error"
                                        @click="$emit('delete-variable', variavel.id, 'header')"
                                        style="margin-top: 6px;"
                                    >
                                        <v-icon small>mdi-delete</v-icon>
                                    </v-btn>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="12">
                                <v-textarea
                                    :value="editedItem.corpo"
                                    @input="handleFieldInput('corpo', $event)"
                                    @focus="handleFieldFocus('corpo', $event)"
                                    @click="handleFieldClick('corpo', $event)"
                                    @keyup="handleFieldKeyup('corpo', $event)"
                                    @keydown="handleFieldKeydown('corpo', $event)"
                                    :label="bodyLabel"
                                    auto-grow
                                    clearable
                                    counter
                                    ref="corpoTextarea"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                        <v-row justify="center" style="margin-top: -15px;">
                            <v-col cols="12">
                                <v-btn 
                                    color="primary"
                                    small
                                    outlined
                                    @click="handleAddVariable('body')"
                                >
                                    {{ addVariablesText }}
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row justify="start" v-if="variaveisBody.length > 0">
                            <v-col cols="12" sm="3" v-for="(variavel) in variaveisBody" :key="(variavel.campo || 'campos_corpo') + '-' + variavel.id">
                                <div style="display: flex; align-items: flex-start; gap: 8px;">
                                    <v-text-field
                                        v-model="variavel.value"
                                        :label="variableText + ' ' + variavel.key.replace(/\D/g, '')"
                                        outlined
                                        dense
                                        style="flex: 1;"
                                    ></v-text-field>
                                    <v-btn
                                        icon
                                        small
                                        color="error"
                                        @click="$emit('delete-variable', variavel.id, 'body')"
                                        style="margin-top: 6px;"
                                    >
                                        <v-icon small>mdi-delete</v-icon>
                                    </v-btn>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="12" sm="12">
                                <v-text-field
                                    :value="editedItem.rodape"
                                    @input="handleFieldInput('rodape', $event)"
                                    @focus="handleFieldFocus('rodape', $event)"
                                    @click="handleFieldClick('rodape', $event)"
                                    @keyup="handleFieldKeyup('rodape', $event)"
                                    @keydown="handleFieldKeydown('rodape', $event)"
                                    :label="footerLabel"
                                    clearable
                                    solo
                                    :hint="footerHint"
                                    ref="rodapeTextField"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center" style="margin-top: -15px;" v-if="allowsFooterVariables">
                            <v-col cols="12">
                                <v-btn
                                    color="primary"
                                    small
                                    outlined
                                    @click="handleAddVariable('footer')"
                                >
                                    {{ addVariablesText }}
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row justify="start" v-if="allowsFooterVariables && variaveisRodape.length > 0">
                            <v-col cols="12" sm="3" v-for="(variavel) in variaveisRodape" :key="(variavel.campo || 'campos_rodape') + '-' + variavel.id">
                                <div style="display: flex; align-items: flex-start; gap: 8px;">
                                    <v-text-field
                                        v-model="variavel.value"
                                        :label="variableText + ' ' + variavel.key.replace(/\D/g, '')"
                                        outlined
                                        dense
                                        style="flex: 1;"
                                    ></v-text-field>
                                    <v-btn
                                        icon
                                        small
                                        color="error"
                                        @click="$emit('delete-variable', variavel.id, 'footer')"
                                        style="margin-top: 6px;"
                                    >
                                        <v-icon small>mdi-delete</v-icon>
                                    </v-btn>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row v-if="superadmin">
                            <v-col cols="12" sm="2">
                                <v-switch
                                    v-model="internalCanEdit"
                                    color="primary"
                                    :label="editableLabel"
                                ></v-switch>
                            </v-col>
                            <v-col cols="12" sm="2">
                                <v-switch
                                    v-model="internalCanDelete"
                                    color="primary"
                                    :label="deletableLabel"
                                ></v-switch>
                            </v-col>
                            <v-col cols="12" sm="2">
                                <v-switch
                                    v-model="internalSendToMeta"
                                    color="primary"
                                    :label="sendToMetaLabel"
                                    :disabled="isMetaTemplate"
                                ></v-switch>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'EditTemplateDialog',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: 'Template'
        },
        editedItem: {
            type: Object,
            default: () => ({
                titulo: null,
                cod_template: null,
                descricao: null,
                corpo: null,
                rodape: null
            })
        },
        variavelDescription: {
            type: Array,
            default: () => []
        },
        variaveisBody: {
            type: Array,
            default: () => []
        },
        variaveisRodape: {
            type: Array,
            default: () => []
        },
        contadorVariaveisBody: {
            type: Number,
            default: 1
        },
        contadorVariaveisHeader: {
            type: Number,
            default: 1
        },
        contadorVariaveisRodape: {
            type: Number,
            default: 1
        },
        canEdit: {
            type: Boolean,
            default: true
        },
        canDelete: {
            type: Boolean,
            default: true
        },
        sendToMeta: {
            type: Boolean,
            default: false
        },
        superadmin: {
            type: Boolean,
            default: false
        },
        titleLabel: {
            type: String,
            default: 'Título'
        },
        codeLabel: {
            type: String,
            default: 'Código'
        },
        headerLabel: {
            type: String,
            default: 'Cabeçalho'
        },
        bodyLabel: {
            type: String,
            default: 'Corpo'
        },
        footerLabel: {
            type: String,
            default: 'Rodapé'
        },
        footerHint: {
            type: String,
            default: 'Texto opcional para rodapé da mensagem (máx. 200 caracteres)'
        },
        editableLabel: {
            type: String,
            default: 'Editável'
        },
        deletableLabel: {
            type: String,
            default: 'Deletável'
        },
        sendToMetaLabel: {
            type: String,
            default: 'Enviar para Meta'
        },
        addVariableText: {
            type: String,
            default: 'Adicionar variável'
        },
        addVariablesText: {
            type: String,
            default: 'Adicionar variáveis'
        },
        variableText: {
            type: String,
            default: 'Variável'
        },
        saveText: {
            type: String,
            default: 'Salvar'
        },
        formValid: {
            type: Boolean,
            default: false
        },
        metaTemplateMessage: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            cursorPosition: {
                descricao: 0,
                corpo: 0,
                rodape: 0
            }
        };
    },
    computed: {
        isMetaTemplate() {
            return !!(this.editedItem && this.editedItem.id_template_meta);
        },
        // Meta não permite variáveis no rodapé; header/corpo usam a mesma UI
        allowsFooterVariables() {
            return !this.sendToMeta && !this.isMetaTemplate;
        },
        internalDialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        internalFormValid: {
            get() {
                return this.formValid;
            },
            set(value) {
                this.$emit('update:formValid', value);
            }
        },
        internalCanEdit: {
            get() {
                return this.canEdit;
            },
            set(value) {
                this.$emit('update:canEdit', value);
            }
        },
        internalCanDelete: {
            get() {
                return this.canDelete;
            },
            set(value) {
                this.$emit('update:canDelete', value);
            }
        },
        internalSendToMeta: {
            get() {
                return this.sendToMeta;
            },
            set(value) {
                this.$emit('update:sendToMeta', value);
            }
        },
        isCodDisabled() {
            return !!(this.editedItem && this.editedItem.id_template != null);
        }
    },
    methods: {
        updateField(field, value) {
            const updated = { ...this.editedItem, [field]: value };
            this.$emit('update:editedItem', updated);
        },
        handleTituloInput(value) {
            this.$emit('filter-titulo', value);
        },
        handleClose() {
            this.$emit('close');
        },
        handleSave() {
            this.$emit('save');
        },
        validate() {
            return this.$refs.form.validate();
        },
        resetValidation() {
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        },
        getCursorPosition(element) {
            if (!element) return 0;
            try {
                return element.selectionStart || 0;
            } catch (e) {
                return 0;
            }
        },
        updateCursorPosition(field, event) {
            const element = event.target;
            if (element) {
                this.cursorPosition[field] = this.getCursorPosition(element);
                }
        },
        handleFieldFocus(field, event) {
            this.$nextTick(() => this.updateCursorPosition(field, event));
        },
        handleFieldClick(field, event) {
            this.$nextTick(() => this.updateCursorPosition(field, event));
        },
        handleFieldKeyup(field, event) {
            this.updateCursorPosition(field, event);
        },
        handleFieldKeydown(field, event) {
            if (event.key !== 'Backspace' && event.key !== 'Delete' && !(event.key === 'x' && (event.ctrlKey || event.metaKey))) return;
            
            const element = event.target;
            const start = element.selectionStart;
            const end = element.selectionEnd;
            const texto = this.editedItem[field] || '';
            
            const regex = /\{\{\d+\}\}/g;
            let match;
            
            while ((match = regex.exec(texto)) !== null) {
                const varStart = match.index;
                const varEnd = match.index + match[0].length;
                
                // Se há seleção que intersecta a variável, prevenir
                if (start !== end && ((start >= varStart && start < varEnd) || (end > varStart && end <= varEnd) || 
                    (start <= varStart && end >= varEnd))) {
                    event.preventDefault();
                    return false;
                }
                
                // Para Backspace: prevenir apenas se o caractere deletado (start-1) está dentro da variável
                if (event.key === 'Backspace' && start === end && start - 1 >= varStart && start - 1 < varEnd) {
                    event.preventDefault();
                    return false;
                }
                
                // Para Delete: prevenir apenas se o caractere deletado (start) está dentro da variável
                if (event.key === 'Delete' && start === end && start >= varStart && start < varEnd) {
                    event.preventDefault();
                    return false;
                }
            }
        },
        handleFieldInput(field, value) {
            // Verificar se alguma variável foi removida
            const textoAnterior = this.editedItem[field] || '';
            const textoNovo = value;
            
            const regex = /\{\{\d+\}\}/g;
            const variaveisAnteriores = [...textoAnterior.matchAll(regex)].map(m => m[0]);
            const variaveisNovas = [...textoNovo.matchAll(regex)].map(m => m[0]);
            
            // Se o número de variáveis diminuiu, restaurar o texto anterior
            if (variaveisNovas.length < variaveisAnteriores.length) {
                this.$nextTick(() => {
                    const refMap = {
                        descricao: { ref: 'descricaoTextField', selector: 'input' },
                        corpo: { ref: 'corpoTextarea', selector: 'textarea' },
                        rodape: { ref: 'rodapeTextField', selector: 'input' },
                    };
                    const cfg = refMap[field];
                    const element = cfg && this.$refs[cfg.ref]?.$el?.querySelector(cfg.selector);
                    if (element) {
                        element.value = textoAnterior;
                        this.updateField(field, textoAnterior);
                    }
                });
                return;
            }
            
            this.updateField(field, value);
        },
        handleAddVariable(tipo) {
            if (tipo === 'footer' && !this.allowsFooterVariables) {
                return;
            }

            const cursorPos = tipo === 'header'
                ? this.cursorPosition.descricao
                : (tipo === 'footer' ? this.cursorPosition.rodape : this.cursorPosition.corpo);

            const contador = tipo === 'header'
                ? this.contadorVariaveisHeader
                : (tipo === 'footer' ? this.contadorVariaveisRodape : this.contadorVariaveisBody);

            this.$emit('add-variable', contador, tipo, cursorPos);
        }
    }
}
</script>

